<mat-list-item class="action-container">
    <div class="list-row">
        <div class="label-container">
            <span>{{label}}</span>
        </div>
        <div class="labeled-button-container">
            <button class="labeled-button" mat-button (click)="action()" [disabled]="isDisabled">
                <mat-icon>{{icon}}</mat-icon>
            </button>
            <mat-icon class="help-icon" [matTooltip]="hint">help</mat-icon>
        </div>
    </div>
</mat-list-item>